import { ColorEnum } from '@/constants/color'
import type { ExpressionSpecification } from 'mapbox-gl'

export const orderStyle = {
    iconImage: 'order',
    iconAnchor: 'bottom' as const,
    textField: ['get' as const, 'label'] satisfies ExpressionSpecification,
    textAnchor: 'center' as const,
    textColor: ColorEnum.GRAY_900,
    allowOverlap: true,
    sortKey: ['get' as const, 'sortKey'] satisfies ExpressionSpecification,
}

export const clusterStyle = {
    color: ColorEnum.YELLOW_500,
    radius: 20,
    strokeColor: ColorEnum.WHITE,
    strokeWidth: 2,
}

export const clusterCountStyle = {
    textField: ['get' as const, 'point_count'] satisfies ExpressionSpecification,
    textSize: 14,
    textColor: ColorEnum.GRAY_900,
    allowOverlap: true,
}
